import { render } from "./AmountOfVisitors.vue?vue&type=template&id=8cc186ec"
import script from "./AmountOfVisitors.vue?vue&type=script&lang=js"
export * from "./AmountOfVisitors.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__